<template>
  <div class="htmleaf-container">
    <div class="loader">
      <div class="my-loading"></div>
      <div class="my-loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
/* .container-loading {
  height: 100%;
  width: 100%;
} */
.htmleaf-container {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;

  min-height: 60px;
  background-color: rgba(255, 255, 255, 0.8);
}

.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
}

.loader .my-loading {
  position: relative;
  width: 100%;
  height: 10px;
  border: 1px solid #30b08f;
  border-radius: 10px;
  // animation: turn 2s linear 0.42s infinite;
  animation: 2s linear 0.42s infinite;
}

.loader .my-loading:before {
  content: "";
  display: block;
  position: absolute;
  width: 0%;
  height: 100%;
  background: #5691f2;
  box-shadow: 10px 0px 15px 0px #5691f2;
  animation: load 1s linear infinite;
}

.loader .my-loading-text {
  width: 100%;
  position: absolute;
  top: 10px;
  color: #5691f2;
  text-align: center;
  margin-top: 10px;
  // animation: bounce 1s linear infinite;
}

@keyframes load {
  0% {
    width: 0%;
  }

  87.5%,
  100% {
    width: 100%;
  }
}

@keyframes turn {
  0% {
    transform: rotateY(0deg);
  }

  6.25%,
  50% {
    transform: rotateY(180deg);
  }

  56.25%,
  100% {
    transform: rotateY(360deg);
  }
}

@keyframes bounce {
  0%,
  100% {
    top: 10px;
  }

  12.5% {
    top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/directiveLoading/loading/Loading.vue